import { rebuildDecimalField } from './serviceConditions';
import { parseDecimal } from './serviceDecimal';
const boundValue = (range)=>{
    var _ref, _ref1, _ref2, _ref3, _range_eq;
    if (range == null) return '';
    return (_ref = (_ref1 = (_ref2 = (_ref3 = (_range_eq = range.eq) !== null && _range_eq !== void 0 ? _range_eq : range.gte) !== null && _ref3 !== void 0 ? _ref3 : range.gt) !== null && _ref2 !== void 0 ? _ref2 : range.lte) !== null && _ref1 !== void 0 ? _ref1 : range.lt) !== null && _ref !== void 0 ? _ref : '';
};
export const isValidPriceRange = (param)=>{
    let { min, max } = param;
    if (min === '' && max === '') return false;
    if (min !== '' && !parseDecimal(min)) return false;
    if (max !== '' && !parseDecimal(max)) return false;
    return min === '' || max === '' || Number(min) <= Number(max);
};
export const hasServicePrice = (predicate)=>predicate.priceMin != null || predicate.priceMax != null;
export const servicePriceValue = (predicate)=>({
        min: boundValue(predicate.priceMin),
        max: boundValue(predicate.priceMax)
    });
export const servicePriceLabel = (predicate, t)=>{
    const { min, max } = servicePriceValue(predicate);
    if (min !== '' && max !== '') return t.servicesPriceBetween({
        min,
        max
    });
    if (min !== '') return t.servicesPriceOver({
        value: min
    });
    if (max !== '') return t.servicesPriceUpTo({
        value: max
    });
    return '';
};
export const rebuildServicePrice = (predicate, param)=>{
    let { min, max } = param;
    var _rebuildDecimalField;
    const withMin = (_rebuildDecimalField = rebuildDecimalField(predicate, 'priceMin', min === '' ? undefined : {
        gte: min
    })) !== null && _rebuildDecimalField !== void 0 ? _rebuildDecimalField : {};
    return rebuildDecimalField(withMin, 'priceMax', max === '' ? undefined : {
        lte: max
    });
};
export const removeServicePrice = (predicate)=>{
    var _rebuildDecimalField;
    const withoutMin = (_rebuildDecimalField = rebuildDecimalField(predicate, 'priceMin', undefined)) !== null && _rebuildDecimalField !== void 0 ? _rebuildDecimalField : {};
    return rebuildDecimalField(withoutMin, 'priceMax', undefined);
};
